import script from "./Name_level.vue?vue&type=script&setup=true&lang=js"
export * from "./Name_level.vue?vue&type=script&setup=true&lang=js"

import "./Name_level.vue?vue&type=style&index=0&id=01bd105e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bd105e"]])

export default __exports__